import React from 'react';
import { Image, ImageOverlay } from 'seduo-ui';
const Square = () => <div style={{ width: '24px', height: '24px', background: 'black' }}/>;
const Example = () => (<div style={{ width: '300px' }}>
        <ImageOverlay topLeft={<Square />} topRight={<Square />} bottomLeft={<Square />} bottomRight={<Square />}>
            <Image src="https://dummyimage.com/300x200/9fa4a8/fff.png" alt="Image title"/>
        </ImageOverlay>
    </div>);
export default Example;
